import {
  /* reqNonFinishBill, */
  reqTransList,
  reqReserveList,
  reqReserveListCount,
  reqOrderDetail,
  reqMsgList,
} from '@/api/hailState-v2'
import dayjs from 'dayjs'

export default {
  async fetchBillList({ state, commit }) {
    try {
      const { result } = await reqTransList(
        state.kw,
        state.billPaging.npp,
        state.billPaging.currentPage,
        state.task,
        state.picked,
      )
      const res = result.data
      const paging = result.paging
      if (res) {
        commit(
          'setBillList',
          res.map((bill) => {
            // 修改時間的日期格式
            bill.driverGrabOrderDate = bill.driverGrabOrderDate
              ? dayjs(bill.driverGrabOrderDate).format('YYYY-MM-DD HH:mm:ss')
              : null
            bill.getPassengerTime = bill.getPassengerTime
              ? dayjs(bill.getPassengerTime).format('YYYY-MM-DD HH:mm:ss')
              : null
            bill.orderCreatedDate = bill.orderCreatedDate
              ? dayjs(bill.orderCreatedDate).format('YYYY-MM-DD HH:mm:ss')
              : null
            return bill
          }),
        )
        commit('setBillPagingTotalPages', paging.totalPages)
        commit('setBillPagingTotalEntries', paging.totalEntries)
        commit('setLastUpdateTime', dayjs().format('HH:mm:ss'))
      } else {
        commit('setBillList', [])
      }
    } catch (e) {
      console.error(e)
    }
  },
  async fetchDriverMsgList({ commit }, page = 1) {
    try {
      const { result } = await reqMsgList(page)
      commit('setDriverMsgModalList', result)
    } catch (e) {
      console.error(e)
    }
  },
  async fetchReserveList({ state, commit }) {
    let reserveList = []
    let totalEntries = 0
    let totalPages = 0
    try {
      const { result } = await reqReserveList(state.reservePaging.currentPage)
      /* console.log(result) */
      if (result.hasOwnProperty('data')) {
        reserveList = result.data.map((order) => {
          return {
            ...order,
            reservationDate: dayjs(order.reservationDate).format(
              'YYYY-MM-DD HH:mm',
            ),
          }
        })
        totalEntries = result.paging.totalEntries
        totalPages = result.paging.totalPages
      }
      commit('setReserveList', reserveList)
      commit('setReservePagingTotalEntries', totalEntries)
      commit('setReservePagingTotalPages', totalPages)
    } catch (e) {
      console.error(e)
    }
  },
  async fetchReserveListCount({ commit }) {
    try {
      const { result } = await reqReserveListCount()
      commit('setReserveCount', result)
    } catch (e) {
      console.error(e)
    }
  },
  async refreshModalInfo({ state, commit }) {
    try {
      if (state.billModal.hasOwnProperty('id')) {
        const { result } = await reqOrderDetail(state.billModal.id)
        commit('setBillModal', result)
      }
    } catch (e) {
      console.error(e)
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/hailStateV2/actions.js